import React from 'react'
import SkillsSection from './Skills'
import Interests from './Interests'

const SkillsInterests = () => {
  return (
    <> 
        <SkillsSection/>
        <Interests />
    </>
  )
}

export default SkillsInterests